import { io } from 'socket.io-client';

import { authStorage } from './api';

const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:3000/api').replace(/\/$/, '');
const SOCKET_BASE_URL = API_BASE_URL.replace(/\/api$/, '');

export function connectAdminDashboardSocket({ userId, role, onRefresh }) {
  const accessToken = authStorage.getAccessToken();
  if (!accessToken || !userId || !role) {
    return () => {};
  }

  const socket = io(SOCKET_BASE_URL, {
    transports: ['websocket', 'polling'],
  });

  const authenticate = () => {
    socket.emit('authenticate', {
      userId,
      role,
      token: accessToken,
    });
  };

  socket.on('connect', authenticate);
  socket.on('admin-dashboard:refresh', (payload) => {
    if (typeof onRefresh === 'function') {
      onRefresh(payload);
    }
  });

  return () => {
    socket.off('connect', authenticate);
    socket.off('admin-dashboard:refresh');
    socket.disconnect();
  };
}
